import { Marker, Polyline, useGoogleMap } from "@react-google-maps/api"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { useSelectedOrdersArray } from "store/dispatch.redux"
import { getPosition } from "utils/custom.utils"
import OrderMarkers from "./OrderMarkers"

const RoutePreview = () => {
  const src = useSelector((state: any) => state.dispatch.sourceDepot?.location)
  const dest = useSelector(
    (state: any) => state.dispatch.destinationDepot?.location
  )
  const route = useSelector((state: any) => state.dispatch.route)
  const orders = useSelectedOrdersArray()

  const map = useGoogleMap()
  useEffect(() => {
    const bounds = new window.google.maps.LatLngBounds()
    orders &&
      orders.forEach(o => {
        bounds.extend(getPosition(o?.shippingAddress))
      })
    bounds.extend(getPosition(src))
    bounds.extend(getPosition(dest))
    map.fitBounds(bounds)
    /**
     * We do this becuase adding orders and map as dependecies causes the effect to run evey time
     * Which leads to bugs and bad user experience, on the contrary we want to to run only when the component mounts (when isPreviewOpen is toggeled)
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      {src && (
        <Marker
          title="Source"
          icon={{
            scaledSize: new window.google.maps.Size(41, 41),
            url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
          }}
          position={getPosition(src)}
        />
      )}
      {dest && (
        <Marker
          title="Destination"
          icon={{
            scaledSize: new window.google.maps.Size(41, 41),
            url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
          }}
          position={getPosition(dest)}
        />
      )}
      {route && (
        <Polyline
          options={{
            strokeColor: "#FFDC42",
          }}
          path={route}
        />
      )}
      <OrderMarkers orders={orders} showSerial={true} />
    </>
  )
}

export default RoutePreview
